/* istanbul ignore file */
export * from './Layout2';
